import React from 'react';
import PropTypes from 'prop-types';
import Task from '../../TasksContainer/ProjectsTasksContainer/TaskList/Task';
import animator from '../../../helpers/animator';
import { connect } from 'react-redux';
import checkmarkClipboard from '../../../assets/images/task-icon-gray.svg';
import offlineCloudIcon from '../../../assets/images/offline-cloud-double-slash.svg';

import toggle from '../../../assets/images/ao-toggle-on.png';
import './MobileMyTasks.scss';
import BaseComponent from '../../../baseClasses/BaseComponent';

export class MobileMyTasks extends BaseComponent {
  
  constructor(props){
    super(props);
    this.animator = new animator();
    this.state = {
      scrollPositionTasks: localStorage.getItem('scrollPositionTasks') && localStorage.getItem('scrollPositionTasks')!= 0?localStorage.getItem('scrollPositionTasks'):0,
      scroll: null,
    
    };
      // if(sessionStorage.getItem("tasksString") == null) {
      //   sessionStorage.setItem("tasksString", JSON.stringify(this.props.tasks));
      // }
      
    MobileMyTasks.propTypes = {
      project: PropTypes.object.isRequired,
    };
    this.handleClickScroll = this.handleClickScroll.bind(this);
  }

  componentDidMount() {
    //this.prev = window.scrollY;
    var tasks = sessionStorage.getItem('tasksString');
    if (this.state.scrollPositionTasks) {
      this.scrollContainerTop=localStorage.getItem('scrollPositionTasks');
      this.scrollContainerListTasks.scrollTop = this.scrollContainerTop;
    }
    if(tasks) {
      this.setState({ tasks: JSON.parse(tasks) }); 
    }
     
  }

  componentDidUpdate(prevProps,prevState) {
    if (prevProps.actionCableUpdate != this.props.actionCableUpdate) {
      this.setState({ actionCableUpdate: this.props.actionCableUpdate });
    }
    if (this.scrollContainerListTasks) {
      this.scrollContainerListTasks.scrollTop = this.scrollContainerTop;
    }  
  }

  handleClickScroll(e){
    localStorage.setItem('scrollPositionTasks', this.state.scrollPositionTasks);
  };

  handleScroll(e){
    const scrollContainerListTasks = e.target;
    this.scrollContainerTop = scrollContainerListTasks.scrollTop;
    
    this.setState({
      scrollPositionTasks: this.scrollContainerTop,
    });
    
  }

  render(){
    const { tasks, project } = this.props;

    let tasksList;
    if(tasks && tasks.length){
      tasksList = tasks.map(task => <Task handleClickScroll={this.handleClickScroll} key={'mobile-' + task.id} project={project} task={task} />);
    }
    else if (this.props.online) {
      tasksList = (
        <div className="empty-tasks" key="empty-task-list" ref={el => this.scrollContainerListTasks =   el }  onScroll={this.handleScroll}>
          <img className="empty-tasks__image" src={checkmarkClipboard} alt="empty tasks" />
          <p className="empty-tasks__description">{!tasks || this.props.pending ? 'Retrieving Tasks Now' : 'No Tasks Found'}</p>
          {tasks && !this.props.pending && <p className="empty-tasks__description"></p>}
          {tasks && !this.props.pending && <p className="empty-tasks__description2">Looking for something?</p>}
          {tasks && !this.props.pending && <p className="empty-tasks__description2">Select &#9733; to Favorite a Project and make it available offline.</p>}
        </div>
      );
    }
    else {
      tasksList = (
        <div className="offline-no-tasks"  key="offline-task-list">
          <img className="offline-no-tasks__image" src={offlineCloudIcon} alt="No Internet Connection" />
          <p className="offline-no-tasks__description">Some results may be unavailable in Offline Mode</p>
        </div>
      );
    }

    return (
      <div className="mobile-mytasks-container" ref={el => this.scrollContainerListTasks =   el }  onScroll={this.handleScroll}>
        {tasksList}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    
  };
};

export default connect(mapStateToProps)(MobileMyTasks);




// WEBPACK FOOTER //
// ./src/containers/ProjectDetailsContainer/MobileMyTasks/index.js